<div class="layout-topbar">
    <div class="layout-topbar-wrapper">
        <div class="layout-topbar-left">
            <a tabindex="0" class="menu-button" (click)="appMain.onMenuButtonClick($event)">
                <i class="pi pi-bars"></i>
            </a>
            <a tabindex="0" id="logo-link" class="layout-topbar-logo" (click)="appMain.onMenuButtonClick($event)">
                <img src="assets/images/backend-image/header/logo.png" alt="TPL sport logo"/>
            </a>
        </div>

        <app-menu></app-menu>

        <div class="layout-topbar-right">
          <div class="mainHeaderDashboard">
              <div class="leftTitle">
                <h2>{{ activeModule }}</h2>
            </div>
            <div class="rightmenues">
                 <ul class="layout-topbar-actions">
                <li #searchItem class="topbar-item search-item active-topmenuitem"  >
                    <a tabindex="0" (click)="appMain.onTopbarItemClick($event,searchItem)">
                        <i class="topbar-icon pi pi-search"></i>
                    </a>

                    <div class="search-input-wrapper">
                        <span class="p-input-icon-left">
                            <img src="../assets/images/backend-image/header/search.svg" alt="">
                            <input type="text" pInputText placeholder="Search" (click)="appMain.searchClick = true;"/>
                        </span>
                    </div>

                    <ul class="fadeInDown">
                        <div class="search-input-wrapper p-fluid" style="width: 100%">
                            <span class="p-input-icon-left">
                                <img src="../assets/images/backend-image/header/search.svg" alt="">
                                <input type="text" pInputText placeholder="Search " (click)="appMain.searchClick = true;"/>
                            </span>
                        </div>
                    </ul>
                </li>
            
           

           

                <li #profile class="topbar-item user-profile" [ngClass]="{'active-topmenuitem fadeInDown': appMain.activeTopbarItem === profile}">
                    <a (click)="op.toggle($event)" class="userBtn" >
                        <div class="userProfilediv">
                            <div class="leftdiv">
                                  <img [src]="(profilepic) ? profilepic : '../../../../assets/images/academy_dummy.jpg'" alt="freya-layout"/>
                          <span class="dashboard-greeting-msg"> {{username}}</span> 
                            </div>
                            <div class="rightdiv">
                                <div class="icon">
                                    <img src="../assets/images/backend-image/header/arowDown.svg" alt="">
                                </div>
                            </div>
                                 
                        </div>
                        <!-- <img src="assets/layout/images/avatar-profilemenu.png" alt="freya-layout"/> -->
                     
                    </a>
                    <p-overlayPanel #op [showCloseIcon]="false" [style]="{width: '200px'}">
                        <ng-template pTemplate>
                            <ul class="fadeInDown user-list">
                                <li>
                                    <a href="manage/admin/{{loggedInUserId}}">
                                        <span> <i class="pi pi-user-edit mr-1"></i> Profile</span>
                                    </a>
                                </li>
                                <!-- <li>
                                    <a href="#">
                                        <span>Settings</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <span>Messages</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <span>Notifications</span>
                                    </a>
                                </li> -->
                                <li>
                                    <a href="#" (click)="logout()">
                                        <span><i class="pi pi-sign-out mr-1"></i> Logout</span>
                                    </a>
                                </li>
                            </ul>
                        </ng-template>
                    </p-overlayPanel>
                </li>
            </ul>
            </div>
          </div>
           

           <!--  <a href="#" tabindex="0" class="layout-rightpanel-button" (click)="appMain.onRightPanelClick($event)">
                <i class="pi pi-arrow-left"></i>
            </a> -->
        </div>
    </div>
</div>
